export type GoodsTableColumnKey =
  | 'image'
  | 'displayName'
  | 'sku'
  | 'category'
  | 'type'
  | 'gtin'
  | 'stock'
  | 'unit'
  | 'unitPrice'
  | 'unitCost'
  | 'status'
  | 'updatedAt';

export interface GoodsTableColumnDescriptor {
  key: GoodsTableColumnKey;
  labelKey: string;
  locked: boolean;
}

export type GoodsTableColumnVisibility = Record<GoodsTableColumnKey, boolean>;

export const GOODS_TABLE_COLUMNS: readonly GoodsTableColumnDescriptor[] = [
  { key: 'image', labelKey: 'COMPONENTS.GOODS.FIELDS.IMAGE', locked: true },
  { key: 'displayName', labelKey: 'COMPONENTS.GOODS.FIELDS.DISPLAY_NAME', locked: true },
  { key: 'sku', labelKey: 'COMPONENTS.GOODS.FIELDS.SKU', locked: false },
  { key: 'category', labelKey: 'COMPONENTS.GOODS.FIELDS.CATEGORY', locked: false },
  { key: 'type', labelKey: 'COMPONENTS.GOODS.FIELDS.TYPE', locked: false },
  { key: 'gtin', labelKey: 'COMPONENTS.GOODS.FIELDS.GTIN', locked: false },
  { key: 'stock', labelKey: 'COMPONENTS.GOODS.FIELDS.STOCK', locked: false },
  { key: 'unit', labelKey: 'COMPONENTS.GOODS.FIELDS.UNIT', locked: false },
  { key: 'unitPrice', labelKey: 'COMPONENTS.GOODS.FIELDS.UNIT_PRICE', locked: false },
  { key: 'unitCost', labelKey: 'COMPONENTS.GOODS.FIELDS.UNIT_COST', locked: false },
  { key: 'status', labelKey: 'COMPONENTS.GOODS.FIELDS.STATUS', locked: false },
  { key: 'updatedAt', labelKey: 'COMPONENTS.GOODS.FIELDS.UPDATED_AT', locked: false },
];

export function buildDefaultColumnVisibility(): GoodsTableColumnVisibility {
  const result = {} as GoodsTableColumnVisibility;
  for (const column of GOODS_TABLE_COLUMNS) {
    result[column.key] = true;
  }
  return result;
}

export function mergeColumnVisibility(
  stored: Record<string, boolean>,
): GoodsTableColumnVisibility {
  const result = buildDefaultColumnVisibility();
  for (const column of GOODS_TABLE_COLUMNS) {
    if (column.locked) {
      continue;
    }
    const storedValue = stored[column.key];
    if (typeof storedValue === 'boolean') {
      result[column.key] = storedValue;
    }
  }
  return result;
}

export function extractPersistableVisibility(
  visibility: GoodsTableColumnVisibility,
): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  for (const column of GOODS_TABLE_COLUMNS) {
    if (!column.locked) {
      result[column.key] = visibility[column.key];
    }
  }
  return result;
}
